export default {"src":"/_next/static/media/icon_search.1d2291fa.svg","height":14,"width":13,"blurWidth":0,"blurHeight":0};